document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector("[data-restock-modal]");
  if (modal) {
    const titleEl = modal.querySelector("[data-restock-product-title]");
    const titleInput = modal.querySelector("[data-restock-input-title]");
    const form = modal.querySelector("#RestockActualForm");
    const contactInput = modal.querySelector("[data-restock-contact]");
    const successMsg = modal.querySelector("[data-restock-success]");
    const submitBtn = modal.querySelector(".restock-submit-btn");
    const fieldGroup = modal.querySelector(".restock-field-group");

    const openModal = (title, variantId) => {
      const prodName = title || "Mahalaxmi Gajak Item";
      if (titleEl) titleEl.textContent = prodName;
      if (titleInput) titleInput.value = prodName;
      if (successMsg) successMsg.style.display = "none";
      if (fieldGroup) fieldGroup.style.display = "block";
      if (submitBtn) {
        submitBtn.style.display = "inline-flex";
        submitBtn.disabled = false;
        submitBtn.querySelector('span') && (submitBtn.querySelector('span').textContent = 'Notify Me On Restock');
      }
      if (contactInput) contactInput.value = "";
      modal.classList.add("is-active");
      modal.setAttribute("aria-hidden", "false");
    };

    const closeModal = () => {
      modal.classList.remove("is-active");
      modal.setAttribute("aria-hidden", "true");
    };

    document.addEventListener("click", (e) => {
      const trigger = e.target.closest("[data-open-restock]");
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        const title = trigger.getAttribute("data-product-title") || trigger.closest("[data-product-title]")?.getAttribute("data-product-title");
        const variantId = trigger.getAttribute("data-variant-id");
        openModal(title, variantId);
      }

      if (e.target.closest("[data-restock-close]")) {
        closeModal();
      }
    });

    if (form) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const contact = contactInput ? contactInput.value.trim() : "";
        const title = titleInput ? titleInput.value : "Mahalaxmi Gajak Item";
        if (!contact) return;

        const isEmail = contact.includes("@");
        const cleanPhone = isEmail ? "" : contact.replace(/[^0-9]/g, "");
        const validEmail = isEmail ? contact : ("restock-" + (cleanPhone || "customer") + "@mahalaxmigajak.com");
        const timestamp = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.querySelector('span') && (submitBtn.querySelector('span').textContent = 'Submitting...');
        }

        const formData = new FormData();
        formData.append("form_type", "contact");
        formData.append("utf8", "✓");
        formData.append("contact[tags]", "restock_lead, notify_me");
        formData.append("contact[Request_Type]", "Restock Alert Request");
        formData.append("contact[Product]", title);
        formData.append("contact[email]", validEmail);
        if (cleanPhone) {
          formData.append("contact[phone]", cleanPhone);
        }
        formData.append("contact[body]", "🔔 RESTOCK NOTIFICATION REQUEST:\n\nProduct: " + title + "\nCustomer Contact (WhatsApp / Email): " + contact + "\nDate & Time: " + timestamp + "\n\nPlease notify this customer when this item is back in stock.");

        fetch("/contact#contact_form", {
          method: "POST",
          body: formData
        }).then(() => {
          if (fieldGroup) fieldGroup.style.display = "none";
          if (submitBtn) submitBtn.style.display = "none";
          if (successMsg) successMsg.style.display = "block";
          setTimeout(() => { closeModal(); }, 3500);
        }).catch(() => {
          if (fieldGroup) fieldGroup.style.display = "none";
          if (submitBtn) submitBtn.style.display = "none";
          if (successMsg) successMsg.style.display = "block";
          setTimeout(() => { closeModal(); }, 3500);
        });

        return false;
      });
    }
  }
});
